import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import UIButton from 'Components/UIComponents/UIButton';
import useSendEmailConfirmation from 'Hooks/Auth/useSendConfirmationEmail';
import { useBeaconRemove } from 'Hooks/Common';
import { UnauthorizedRoutePaths } from 'Interfaces/RoutePaths';
import { User } from 'Interfaces/User';
import Toast from 'Services/Toast';
import { selectUser } from 'Utils/selectors';

import SignUpConfirmImg from 'Assets/images/bg/signUpConfirm.svg';

interface SignUpConfirmationProps {
  confirmationRequired: boolean;
}

const SignUpConfirm = () => {
  useBeaconRemove();
  const navigate = useNavigate();
  const locationState = useLocation().state as SignUpConfirmationProps;

  useEffect(() => {
    if (!locationState || !locationState.confirmationRequired) {
      navigate(UnauthorizedRoutePaths.BASE_PATH);
    }
  });

  const { email } = useSelector(selectUser) as Required<User>;

  const [sendConformationEmail, isLoading] = useSendEmailConfirmation();

  const handleConfirmationEmailSend = useCallback(async () => {
    try {
      await sendConformationEmail({ email });
      Toast.success('Email has been sent');
    } catch (error) {
      Toast.handleErrors(error);
    }
  }, [email, sendConformationEmail]);

  return (
    <div className="signup_confirm">
      <div className="signup_confirm__wrapper">
        <div className="signup_confirm__img">
          <ReactSVG src={SignUpConfirmImg} />
        </div>
        <div className="signup_confirm__text">
          <div className="signup_confirm__text--major">
            Please confirm your email address
          </div>
          <div className="signup_confirm__text--minor">
            Please check your inbox for a confirmation email from Signaturely. If you
            can&apos;t find it, please check the SPAM folder.
          </div>
        </div>
        <div className="signup_confirm__button">
          <UIButton
            priority="secondary"
            title="Resend confirmation"
            disabled={isLoading}
            handleClick={handleConfirmationEmailSend}
          />
        </div>
      </div>
    </div>
  );
};

export default SignUpConfirm;
